import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../client";

const CURRENT_USER_KEY = ["users", "me"];

async function fetchCurrentUser() {
  const response = await apiClient.get("/api/v1/users/me/");
  return response.data;
}

/**
 * TanStack Query hook for the authenticated user's profile.
 * The access token is attached automatically by the interceptor registered in AuthProvider.
 */
function useCurrentUser(options = {}) {
  return useQuery({
    queryKey: CURRENT_USER_KEY,
    queryFn: fetchCurrentUser,
    staleTime: 5 * 60 * 1000, // 5 min — user profile changes rarely
    ...options,
  });
}

export { useCurrentUser, CURRENT_USER_KEY };
